import React from 'react';
import { buildImageUrl } from '@/utils/imageLoader';

type ImageProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
  src: string;
  alt: string;
  width: number;
  height?: number;
  quality?: number;
};

export function Image({ src, width, height, quality = 75, alt, style, ...rest }: ImageProps) {
  const url = buildImageUrl({ src, width, quality });

  return (
    <img
      src={url}
      alt={alt}
      width={width}
      height={height}
      loading={rest.loading ?? 'lazy'}
      decoding={rest.decoding ?? 'async'}
      style={style}
      {...rest}
    />
  );
}

export default Image;
